import './orders.scss';

import React, { useState } from 'react';

import SearchIcon from '@mui/icons-material/Search';
import { Button, FormControl, InputGroup, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { setMessage } from '../toasts/toastSlice';
import {
  setOrdersToDeliverFilters,
  setOrdersToRetrieveFilters,
  setOrdersToReturnFilters,
} from './orderSlice';
import { useTranslation } from 'react-i18next';

const SearchBar = ({ placeholder }) => {
  const {
    ordersToRetrieveFilters,
    ordersToDeliverFilters,
    ordersToReturnFilters,
  } = useSelector((state) => state.orders);
  const { t } = useTranslation(['system']);
  const [temporalFilter, setTemporalFilter] = useState('');

  const dispatch = useDispatch();

  // Update filters
  const handleSubmit = () => {
    if (temporalFilter.length > 200) {
      dispatch(
        setMessage({
          body: t('SEARCH_BAR_VALIDATION_LENGTH', { ns: 'system' }),
          type: 'error',
        })
      );
    } else {
      dispatch(
        setOrdersToDeliverFilters({
          filter: temporalFilter,
          page: 1,
          id_city: ordersToDeliverFilters.id_city,
        })
      );
      dispatch(
        setOrdersToRetrieveFilters({
          filter: temporalFilter,
          page: 1,
          id_warecloud: ordersToRetrieveFilters.id_warecloud,
        })
      );
      dispatch(
        setOrdersToReturnFilters({
          filter: temporalFilter,
          page: 1,
          id_warecloud: ordersToReturnFilters.id_warecloud,
        })
      );
    }
  };

  return (
    <Row className="search-bar mt-3">
      <InputGroup>
        <FormControl
          placeholder={placeholder}
          aria-label={placeholder}
          onChange={(e) => setTemporalFilter(e.target.value)}
          className="search-bar__input text-truncate"
        />

        <Button onClick={handleSubmit} className="search-bar__input-button">
          <SearchIcon className="fa-lg" />
        </Button>
      </InputGroup>
    </Row>
  );
};

export default SearchBar;
